var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBni(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 10,
    viewBox: "0 0 23 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.17298 4.25047C8.21953 4.49614 9.05905 5.27099 9.05905 6.51156C9.05905 8.1003 7.72818 9.04394 5.66111 9.04394H0.984375V0H5.57081C7.17298 0 8.55509 0.594252 8.55509 2.37742C8.55509 3.33326 7.84451 3.96656 7.17298 4.22484V4.25047ZM4.79556 3.52728C5.42845 3.52728 5.77744 3.269 5.77744 2.8167C5.77744 2.32576 5.50614 2.08009 4.86023 2.08009H3.76203V3.52728H4.79556ZM5.26088 6.96386C5.9198 6.96386 6.2818 6.74421 6.2818 6.24026C6.2818 5.78796 5.94583 5.54229 5.19661 5.54229H3.76243V6.96345H5.26088",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.3223 4.4575V0H19.0353V9.04394H16.5806L12.808 4.26348H12.782V9.04394H10.043V0H12.782L16.2832 4.4571H16.3219",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.207 0H22.9851L20.207 2.76626V0Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.207 3.82486L22.9851 1.05859V9.04378H20.207V3.82486Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBni);
export default __webpack_public_path__ + "static/media/bni.6193776ac08f1e70f58b4e7a7501212a.svg";
export { ForwardRef as ReactComponent };